exports.onClientEntry = () => {
  if (window.location.pathname === "/hu/") {
    window.location.pathname = `/`;
  }
};
